@if (mainActivity(); as mainActivity) {
  <mat-checkbox
    checked
    (click)="$event.stopPropagation(); $event.preventDefault()"
  >
    {{ mainActivity.role | i18nLookup: activityRoleLabels }}
    {{ mainActivity.target.name }}
  </mat-checkbox>
}

@for (item of sideActivities(); track item.id) {
  <div class="flex flex-row ml-4">
    <div class="flex flex-col w-4">
      <div class="flex-grow border-l border-b border-solid"></div>
      <div class="flex-grow border-solid" [class.border-l]="!$last"></div>
    </div>
    <mat-checkbox (click)="mainActivity.set(item)">
      {{ item.role | i18nLookup: activityRoleLabels }} {{ item.target.name }}
    </mat-checkbox>
  </div>
}
